module.exports = __webpack_public_path__ + "media/hyper/images/email-campaign-5893935769fc15fa21d5a8e792b6e4b5.svg";